import { Loader } from '@googlemaps/js-api-loader';
import { Section } from './jobs-flow/Section';
import { CRUDFabric } from './CRUDs/CRUDFabric';
import { Customer }  from './CRUDs/entities/Customer';
import { SimpleSectionSwitcher } from './components/SimpleSectionSwitcher';
import { HasAttachments } from './CRUDs/abstracts/mixins/HasAttachments';
import { Employee } from './CRUDs/entities/Employee';

export default {
    dropzoneFiles: {},
    init() {
        this.mapInit();
        this.showJobChecklistModal();
        this.showMoreInfo();
        this.toggleViewAllPictures();
        this.changeJobStatus();
        this.viewCustomerCard();
        this.addWorkerComment();
        this.initSection();
        this.initBtns();
        this.loader_lib = false;
        this.initMobileFilters();
        this.initHeaderFilters();
        this.initClickRowTable();
        this.initRouteBtn();
        HasAttachments.setAttachmentCallbackDelete();
        HasAttachments.setAttachmentCallbackPreview();
        //initGlobalMapFunc();
        this.changeStatusSelect();
    },

    initClickRowTable(){
        $('body').off('click', '#worker_cabinet .stafter-table-body tr td:not(.customer-td, .status-td, .checklist-td), #worker_cabinet .bb-mobile-table tr td:not(.status-td)')
        .on('click', '#worker_cabinet .stafter-table-body tr td:not(.customer-td, .status-td, .checklist-td), #worker_cabinet .bb-mobile-table tr td:not(.status-td)', this.getFormForEvent.bind(this))
    },

    initRouteBtn(){
        $('body').off('click', '.get-route-modal')
        .on('click', '.get-route-modal', (ev)=>{
            let date = $(ev.currentTarget).attr('data-date')
            if(window?.user_id){
                let worker = new Employee(window.user_id)
                let data = {
                    date: date,
                    fixed_date:true
                }
                worker.showJobsMap(window.user_id, data)
            }
        })
    },

    getFormForEvent(ev){
        let elem = $(ev.currentTarget)
        if(elem.prop('tagName').toLowerCase() == 'td')
            elem = $(elem.parents('tr')[0])
        const entity = elem.attr('data-inner-entity')
        this.getForm(entity, elem.attr('data-id'))
    },

    getForm(entity, id){
        return new Promise(resolve=>{
            $.ajax({
                type: 'GET',
                url: '/worker-cabinet/form',
                data: {entity,id},
                success: (response) => {
                    $('#form-container').html(response);
                    $(`#${entity}-worker-modal`).modal('show');
                    // Initialize dropzone listener for upload-files buttons in the modal
                    if (entity && id) {
                        const entityClass = CRUDFabric.getClass(entity);
                        if (entityClass) {
                            const entityObj = new entityClass(id);
                            if (entityObj.scopeOpenDropZoneListener) {
                                entityObj.scopeOpenDropZoneListener();
                            }
                        }
                    }
                    // Ensure leave-comments-modal is inside form-container for correct opening
                    const leaveCommentsModal = $('#leave-comments-modal');
                    if (leaveCommentsModal.length && !leaveCommentsModal.closest('#form-container').length) {
                        leaveCommentsModal.detach().appendTo('#form-container');
                    }
                    // Re-initialize leave-comments button handler for dynamically loaded modal
                    $(`#${entity}-worker-modal`).find('.leave-comments').off('click').on('click', (e) => {
                        const entityType = $(e.currentTarget).data('type');
                        const entityId = $(e.currentTarget).data('id');
                        $('#leave-comments-modal').modal('show');
                        $($('#leave-comments-modal button.comment-button')[0]).attr('data-id', entityId);
                        $($('#leave-comments-modal button.comment-button')[0]).attr('data-type', entityType);
                    });
                    //$(`#${entity}-worker-modal #${type}`).on('click', callback.bind(this))
                    resolve(true)
                },
                error:()=>resolve(false)
            });
        })
    },

    initBtns(){
        // leave-comments
        $('body').off('click', '.leave-comments').on('click', '.leave-comments', (e) => {
            const entityType = $(e.currentTarget).data('type');
            // the jobs-flow triggers carry data-job-id / data-visit-id rather than
            // data-id, so reading only data('id') left the id undefined and the
            // save silently did nothing
            const $trigger = $(e.currentTarget);
            const entityId = $trigger.data('id')
                ?? $trigger.data('job-id')
                ?? $trigger.data('visit-id')
                ?? $trigger.data('entity_id');
            // the modal is a singleton, so last time's text and result banner are
            // still sitting in it — reset before showing
            $('#comment-textarea').val('');
            $('#leave-comments-modal .text-success, #leave-comments-modal .text-danger, #leave-comments-modal .error-message')
                .addClass('d-none').filter('.error-message').text('');
            $('#leave-comments-modal').modal('show');
            $('#leave-comments-modal button.comment-button').data('id', entityId);
            $('#leave-comments-modal button.comment-button').data('type', entityType);
        });

        // upload files
        $('.data-tables .more-info-container .upload-file').off('click').on('click', (e) => {
            const entityType = $(e.currentTarget).data('type');
            const entityId = $(e.currentTarget).data('job-id');
            const entityClass = CRUDFabric.getClass(entityType);
            const entity = new entityClass(entityId);
            entity.openDropZone();
        });
    },

    mapInit(for_unversal_modal=false, successCallback=()=>{}) {
        if (this.checkCurrentPath(for_unversal_modal)) {
            /**
             * подключение google.maps скриптов
             */
            if($('meta[name="google-api-key"]').length){
                let _this = this;
                let googlApi = $('meta[name="google-api-key"]').attr('content');
                const apiOptions = {
                    apiKey: googlApi
                };
                const loader = new Loader(apiOptions);
                loader.load().then(() => {
                    successCallback();
                });
                /* let loader;
                import('@googlemaps/js-api-loader').then((module)=>{
                    this.loader_lib = module.Loader;
                }).then(()=>{
                    loader = new this.loader_lib(apiOptions)
                    loader.load().then(() => {

                    });

                }); */
            }
        }
    },
    showChangeStatusModal() {
        $('.status').click(function () {
            let data = {
                type: $(this).data('type'),
                job_id: $(this).data('job_id'),
            }
            $.ajax({
                type: 'POST',
                url: '/worker-cabinet/get-statuses-modal',
                data: data,
                success: function (response) {
                    $('#statuses_modal').html(response);
                    $('#statuses_modal').show();
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
        $('#statuses_modal').on('click', '.close', function () {
            $('#statuses_modal').hide();
        });
    },

    showJobChecklistModal() {
        $('body').off('click', '.checklist-btn')
        .on('click', '.checklist-btn', function () {
            let data = {
                customer_id: $(this).data('customer-id'),
                job_id: $(this).data('id'),
                type: $(this).data('type'),
            }
            $.ajax({
                type: 'POST',
                url: '/worker-cabinet/get-checklist',
                data: data,
                success: function (response) {
                    $('#form-container #job-checklist-modal').remove();
                    $('#form-container').append(response);
                    $('#job-checklist-modal').modal('show');

                    // The runner's "Add photo" on a photo-required step is an ordinary
                    // .upload-files trigger, and NOTHING bound that listener on this page —
                    // getForm() binds it only when a job/visit form modal opens, which is a
                    // different path. Without this the button was inert on the worker's own
                    // screen: the one place the feature exists for.
                    const entity = data.type === 'job' ? 'job' : 'order';
                    const entityClass = CRUDFabric.getClass(entity);
                    if (entityClass) {
                        const entityObj = new entityClass(data.job_id);
                        if (entityObj.scopeOpenDropZoneListener) {
                            entityObj.scopeOpenDropZoneListener();
                        }
                    }
                },
                error: function (response) {
                    console.log(response);
                }
            });
        });
    },

    // markJobsDone() + saveChecklistJobsDone() removed 2026-07-26 (Checklist Marshal). They
    // toggled the row optimistically, then batched every tick into ONE post to
    // /worker-cabinet/change-item-status with empty success AND error handlers, closing the sheet
    // either way — so a failed save looked exactly like a successful one, and Bootstrap was left
    // with modal-open on <body>. js/checklists/runner.js now saves each tap on its own against
    // the authorized item endpoints and surfaces failures per row.

    showMoreInfo() {
        $('#worker_cabinet').on('click', '.show_more_btn', function () {
            let id = $(this).data('id');
            let type = $(this).data('type');
            const svgOpenButton = $(this).find('svg.svg-open');
            const svgCloseButton = $(this).parent('td').find('svg.svg-close');
            if ($('.more-info-' + id + '[data-type='+type+']').hasClass('d-none')) {
                $('.more-info-' + id + '[data-type='+type+']').removeClass('d-none');

                svgCloseButton.addClass('d-flex').removeClass('d-none');
                svgOpenButton.addClass('d-none').removeClass('d-flex');

                $(this).find('.arrow').css('transform', 'rotate(225deg)');
                $(this).find('span').text('Close');
            } else {
                $('.more-info-' + id + '[data-type='+type+']').addClass('d-none');
                $(this).find('.arrow').css('transform', '');
                $(this).find('span').text('More');
                svgCloseButton.addClass('d-none').removeClass('d-flex');
                svgOpenButton.addClass('d-flex').removeClass('d-none');

            }
        });
    },


    addWorkerComment(){
        $(document).off('click.workerComment', 'button.comment-button')
        .on('click.workerComment', 'button.comment-button', function (ev) {
            // Every caller hands the id and type over with jQuery .data(), which
            // writes to jQuery's own store and NEVER touches the DOM attribute.
            // Reading them back with .attr() therefore returned the blade's empty
            // data-job-id / data-type placeholders, so jobId and type were always
            // undefined and the comment was never saved. Read them the same way
            // they are written.
            const $btn = $(ev.currentTarget);
            let jobId = $btn.data('id') ?? $btn.attr('data-id');
            let type = $btn.data('type') ?? $btn.attr('data-type');
            let commentText = $('#comment-textarea').val();
            if (!jobId || !type) {
                $('#leave-comments-modal .error-message')
                    .text('Could not tell which record this comment belongs to.')
                    .removeClass('d-none');
                return;
            }
            const callback = (res) => {
                let messageClass = res.success ? '.text-success':'.text-danger'
                $(`#leave-comments-modal ${messageClass}`).text(res.message)
                $(`#leave-comments-modal ${messageClass}`).removeClass('d-none')
                if(res.success)
                    setTimeout(() => {
                        $(`#leave-comments-modal ${messageClass}`).addClass('d-none')
                        $('#leave-comments-modal').modal('hide');
                        $('#comment-textarea').val("");
                    }, 2500)
            }

            // Posted directly rather than through CRUDFabric.getClass(type).
            // CRUDFabric imports Job, Job imports HasAttachments, and
            // HasAttachments imports CRUDFabric again — that cycle leaves the
            // entity bindings undefined by the time this runs, so
            // `new entityClass(...)` threw "is not a constructor" and the
            // comment was lost. This endpoint only wants the three values we
            // already hold, so there is nothing to construct.
            $.ajax({
                url: '/worker-cabinet/comment/create',
                method: 'POST',
                data: { jobId, type, commentText },
                success: callback,
                error: () => callback({ success: false, message: 'Could not save the comment.' }),
            });
        });
    },

    viewCustomerCard() {
        let _this = this;

        $('body').off('click', '#close-customer-modal').on('click', '#close-customer-modal', e=>{
            $('.modal').modal('hide')
        })

        $('body').off('click','.customer-flyer-btn').on('click', '.customer-flyer-btn', function (e) {
            let element = $(this);
            let customerId = element.data('customer-id');
            let lat = parseFloat(element.data('customer-lat'));
            let lon = parseFloat(element.data('customer-lon'));
            $.ajax({
                url: '/customers/get-customer-modal/' + customerId,
                data:{
                    is_worker:true
                },
                type: 'POST',
                success: function (res) {
                    let prev = $('#form-container').find(`.modal#customer-${customerId}`)
                    if(prev)
                        prev.remove()
                    $('#form-container').append(res);
                    $(`.modal#customer-${customerId}`).modal('show');

                    if ($('.stafter-table-modals').find('#route-map').length > 0) {
                        let lat = $('#customer-lat').val();
                        let lon = $('#customer-lon').val();
                        _this.mapInit();
                        _this.RouteDisplayMap({
                            lat,
                            lon
                        });
                    }

                    /*if(lat && !isNaN(lat)&& lon && !isNaN(lon)){
                        _this.mapInit();
                        _this.RouteDisplayMap({
                            lat,
                            lon
                        });
                    }
                    _this.toggleViewAllPictures();

                    let switchers = document.querySelectorAll('#customer-flyer .switcher');
                    for(let sw of switchers){
                        new SimpleSectionSwitcher(sw)
                    }
                    _this.uploadListener(customerId);*/
                }
            });
        });
    },

    uploadListener(customerId) {
        if(customerId){
            const customer = new Customer(customerId)
            customer.scopeOpenDropZoneListener()
        }
    },

    toggleViewAllPictures() {
        $('.view-images-btn').on('click',function (e) {
            $(this).addClass('d-none')
            if($('#customer-flyer .view-all-images').hasClass('d-none')){
                $('#customer-flyer .images-header-img').addClass('d-none')
                $('#customer-flyer .other-info').addClass('d-none')
                $('#customer-flyer .view-all-images').removeClass('d-none')
                $('#customer-flyer .view-images-back-btn').removeClass('d-none')
            }
        });
        $('.view-images-back-btn').on('click',function (e) {
            $(this).addClass('d-none')
            if(!$('#customer-flyer .view-all-images').hasClass('d-none')){
                $('#customer-flyer .view-all-images').addClass('d-none')
                $('#customer-flyer .images-header-img').removeClass('d-none')
                $('#customer-flyer .other-info').removeClass('d-none')
                $('#customer-flyer .view-images-btn').removeClass('d-none')
            }
        });
    },


    changeJobStatus() {
        $('body').off('change', '.job-status-change').on('change', '.job-status-change', function (ev) {
            const element = $(ev.currentTarget)
            const entity = element.data('entity')
            const status = Number(element.val())
            let data = {
                id: element.data('id'),
                type: entity,
                status,
            }
            const changeStatusEl = ev.currentTarget
            $.ajax({
                type: 'POST',
                url: '/worker-cabinet/change-job-status',
                data: data,
                success: function (response) {
                    $(changeStatusEl).data('prev-status', $(changeStatusEl).val())
                    $(changeStatusEl).addClass('success-status-change')
                    setTimeout(()=>$(changeStatusEl).removeClass('success-status-change'),400)
                    const Entity = CRUDFabric.getClass(entity);
                    if(Entity?.statuses){
                        if(status == Entity.statuses?.COMPLETED || status == Entity.statuses?.CANCELED)
                            element.closest('.data-row').addClass('canceled')
                        else
                            element.closest('.data-row').removeClass('canceled')
                    }
                },
                error: function (response) {
                    $(changeStatusEl).val($(changeStatusEl).data('prev-status'))
                    $(changeStatusEl).addClass('error-status-change')
                    setTimeout(()=>$(changeStatusEl).removeClass('error-status-change'),400)
                }
            });
        });
    },

    RouteDisplayMap(latLonObj) {

        let route_map_center = new google.maps.LatLng(latLonObj.lat, latLonObj.lon);
        let mapCanvas = document.getElementById('route-map');
        let mapOptions = {
            zoom: 15,
            center: route_map_center,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: false,
            scrollwheel: false,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            clickableIcons: false,
            styles: [{"featureType": "administrative", "elementType": "geometry", "stylers": [{"visibility": "off"}]},
                {"featureType": "poi", "stylers": [{"visibility": "off"}]},
                {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]},
                {"featureType": "transit", "stylers": [{"visibility": "off"}]}]
        };

        let route_map = new google.maps.Map(mapCanvas, mapOptions);
        this.RouteMapAddMarkerOrder(latLonObj, route_map);
    },

    RouteMapAddMarkerOrder(latLonObj, map) {

        let marker = new google.maps.Marker({
            position: {
                lat: parseFloat(latLonObj.lat),
                lng: parseFloat(latLonObj.lon),
            },
            map: map,
        });
    },

    initSection() {
        if (window.location.pathname == '/worker-cabinet') {
            const section = new Section('workers-targets', true);
            section.show();
        }
    },

    initHeaderFilters(){
        $('.card-filter').on('click', ev=>{
            let el = $(ev.currentTarget)
            if(window.matchMedia("(max-width: 768px)").matches){
                this.getMobileTable([{name:'date', value:`${el.attr('data-date-filter')} - ${el.attr('data-date-filter')}`}])
            }else{
                $('.stafter-filter[data-type="date-range"]').data('daterangepicker').setStartDate(el.attr('data-date-filter'))
                $('.stafter-filter[data-type="date-range"]').data('daterangepicker').setEndDate(el.attr('data-date-filter'))
                $('.stafter-filter[data-type="date-range"]').val(`${el.attr('data-date-filter')} - ${el.attr('data-date-filter')}`)
                $('.stafter-filter[data-type="date-range"]').data('daterangepicker').element.trigger('apply.daterangepicker',$('.stafter-filter[data-type="date-range"]').data('daterangepicker'))
            }
        })
    },

    initMobileFilters(){
        $('.reset-mob-filters-btn').on('click', ()=>{
            let fields = $('.mobile-filters').find('input, select')
            for(let field of fields){
                if(field.tagName == 'select')
                    $($(field).find(`option`)[0]).prop('selected', true);
                else
                    $(field).val('');
            }
            this.getMobileTable();
        })

        $('.mobile-filters .search').on('input', this.getMobileTable)
        $('.mobile-filters select[name="type"]').on('change', this.getMobileTable)

        let dateInput = $('.mobile-filters').find('input[name="date"]')
        dateInput.daterangepicker();
        dateInput.val('');
        dateInput.on('apply.daterangepicker', (ev, picker) => this.getMobileTable())
        .on('cancel.daterangepicker', (ev, picker) => {
            dateInput.val('');
            this.getMobileTable();
        });
    },

    getMobileTable(fields = null){
        $('.mobile-container .bb-preloader-container').show();
        let data = {}
        let fs = fields ? fields : $('.mobile-filters').find('input, select')
        for (let field of fs) {
            if(field.value != ''){
                if(field.name == 'date'){
                    const dates = field.value.split('-');
                    const start= dates[0].trim().replace(/(\d{2})[\/\\](\d{2})[\/\\](\d{4})/g,'$3-$1-$2');
                    const end = dates[1].trim().replace(/(\d{2})[\/\\](\d{2})[\/\\](\d{4})/g,'$3-$1-$2');
                    data[field.name]={start,end}
                }else{
                    data[field.name] = field.value
                }
            }
        }
        if(Object.keys(data).length>0)
            $('.reset-mob-filters-btn').removeClass('d-none')
        else
            $('.reset-mob-filters-btn').addClass('d-none')
        data['table-type'] = 'mobile'
        $.ajax({
            url: '/worker-cabinet/filter',
            method: 'get',
            dataType: 'json',
            data,
            success: res=>{
                if(res?.view)
                    $('.mobile-container .data-view').replaceWith(res.view)
                $('.mobile-container .bb-preloader-container').hide();
            },
            error:(err)=>{
                console.error(err)
                $('.mobile-container .bb-preloader-container').hide();
            }
        });

    },

    /**
     * Проверка текущей страницы
     *
     * @returns bool [true|false]
     */
    checkCurrentPath(for_unversal_modal=false){
        let currentPath = window.location.pathname;
        const pathesArray = [
            '/worker-cabinet',
            '/customers',
            '/appointments',
            '/jobs-flow',
            '/events'
        ];
        let flag = false;
        pathesArray.forEach(element => {
            if (currentPath == element) {
                flag = true;
            }else if(currentPath.includes(element)){
                return true;
            }
        });
        return (flag || for_unversal_modal);
    },

    changeStatusSelect(){
        $(`body`).off('click', '.worker-modal .status-select')
        .on('click', '.worker-modal .status-select', function(e) {
            const options_container = $(this).find('.status-select-options-container');
            if (options_container.hasClass('d-none')) {
                options_container.removeClass('d-none');
            } else {
                options_container.addClass('d-none');
            }
            let posX = 0;
            let posY = 30;
            options_container.css({right: posX, top: posY});
        });
        $(`body`).off('click', '.worker-modal .status-select .status-select-option')
        .on('click', '.worker-modal .status-select .status-select-option', (e)=>{
            const parent = $(e.currentTarget).parents('.status-select');
            const active_section = $(`#${this.modal_id}`).find('.main-step.active').data('type');
            if ($(parent).hasClass('editing')) {
                $(parent).find('.selected-value').html($(e.currentTarget).html());
                // $(parent).find('#status').val($(e.currentTarget).data('id'));
            } else {
                const entity = $(e.currentTarget).parents('.status-select').data('entity');
                const entity_id = $(e.currentTarget).parents('.status-select').data('entity_id');
                $(e.currentTarget).parents('.status-select').find('.selected-value').html($(e.currentTarget).html());
                let status_id = null;
                if (active_section == 'projects') {
                    status_id = $(e.currentTarget).data('name');
                } else {
                    status_id = $(e.currentTarget).data('id');
                }
                if (!entity || !entity_id || !status_id) {
                    return;
                }
                this.updateStatus(entity,entity_id,status_id);
            }
        });
    },
    updateStatus(entity, entity_id, status_id, ){
        const active_section = $(`#${this.modal_id}`).find('.main-step.active').data('type');
        if (entity !== 'order') {
            $.ajax({
                method: 'POST',
                url: `/jobs-flow/${entity}/${entity_id}/${status_id}`,
                success: (response) => {},
                error: (response) => {
                    console.log(response);
                }
            });
        } else {
            $.ajax({
                method: 'POST',
                url: `order/${entity_id}/change-status`,
                data: {
                    status: status_id
                },
                success: (response)=>{},
                error: (response)=>{
                    console.log(response);
                }
            });
        }
    }

}
